import { render, staticRenderFns } from "./PricingStep.vue?vue&type=template&id=584c9c2f"
import script from "./PricingStep.vue?vue&type=script&lang=js"
export * from "./PricingStep.vue?vue&type=script&lang=js"
import style0 from "./PricingStep.vue?vue&type=style&index=0&id=584c9c2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports